import { useEffect, useRef } from 'react';
import { Flex } from '@radix-ui/themes';
import { useAgent } from '@getdutchie/agent-react';
import { UserBubble } from './user-bubble';
import { AgentMessage } from './agent-message';
import { AgentThinking } from './agent-thinking';

export function Conversation() {
  const { messages, status } = useAgent();
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length, status]);

  return (
    <Flex direction="column" gap="5" py="4">
      {messages.map((msg, i) =>
        msg.role === 'user' ? (
          <UserBubble key={i} content={msg.content} />
        ) : (
          <AgentMessage key={i} content={msg.content} />
        ),
      )}
      <AgentThinking />
      <div ref={bottomRef} />
    </Flex>
  );
}
